<template>

    <q-input
        class="mw-form-v2-input"
        :filled="settings.theme.input.filled"
      :outlined="settings.theme.input.outlined"
      :standout="settings.theme.input.standout"
      :borderless="settings.theme.input.borderless"
      :rounded="settings.theme.input.rounded"
      :square="settings.theme.input.square"
      :dense="settings.theme.input.dense"
        v-model="fieldValue"
        :label="field.layout_injected_label ? field.layout_injected_label : field.label"
        debounce="1000"

        :rules="field.required  ? [

            val => !!val || '* Required',
            val => val.length > 4 || 'Please use minimum 5 chars',
            val => isValidEmail() || 'Please type valid email address'

            ] : []">
      <template v-slot:append>
        <q-icon name="s_email" />
      </template>
       <template v-slot:label>
         {{field.layout_injected_label ? field.layout_injected_label : field.label}}
      <OptionalLabel :field="field"></OptionalLabel>
      </template>
    </q-input>

</template>

<script>
import {mapFields} from "vuex-map-fields";
import OptionalLabel from "@/components/OptionalLabel";
export default {
  props: {
    modelValue: {},
    field:{}
  },
  components: {OptionalLabel},
  data() {
    return {

    };
  },
  emits: ['update:modelValue'],
  methods: {
    isValidEmail() {
      try {
          //eslint-disable-next-line
          return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,5})+$/.test(this.fieldValue);
      } catch (e) {
        console.log(e);
      }
      return false;
    }
  },
  computed: {
    ...mapFields('settings/list', {
      settings: 'settings'
    }),
    requiredText: function () {
      return this.field.required_text ? this.field.required_text : 'email required';
    },
    fieldValue: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit('update:modelValue', value);
      },
    }
  },
  mounted() {

  }
}
</script>
